import React from 'react';
import PropTypes from 'prop-types';
import ModuleGraphItem from './graph-item';


/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ModuleGraph = ({
    itemsCollection,
    singleGraphEditorialVariant,
    parent,
    title,
}) => {
    const items = itemsCollection.items;
    return (
        <>
            <div className={`bg-white relative ${parent === 'Home' ? 'py-40 md:py-50' : parent === 'Detail' ? 'py-20 md:py-30' : 'py-40 md:py-60'} `}>
                <div className='layout-container'>

                    <div className={`bg-white rounded-button ${singleGraphEditorialVariant ? '' : '-mx-10 sm:-mx-35 md:mx-0 sm:px-5 md:px-10'}`}>
                        <div className={`${singleGraphEditorialVariant ? '' : 'bg-sand px-20 sm:px-35 pt-30 pb-80 md:p-50 md:pb-90'}`}>

                            <div className={`sm:px-5 w-full flex flex-wrap ${title ? 'justify-between' : 'justify-end'}`}>
                                {title && !singleGraphEditorialVariant && (
                                    <p className='type-style-3'>{title}</p>
                                )}
                            </div>
                            {singleGraphEditorialVariant ? (
                                <div className='flex flex-row'>
                                    <div className='w-0 sm:w-2/12 md:w-4/12 sm:px-5 md:px-10' />
                                    <div className='w-full sm:w-8/12 md:w-4/12 px-10 sm:px-5 md:px-10'>
                                        <ModuleGraphItem
                                            singleGraphEditorialVariant={singleGraphEditorialVariant}
                                            {...items?.[0]} />
                                    </div>
                                    <div className='w-0 sm:w-2/12 md:w-4/12 sm:px-5 md:px-10' />
                                </div>
                            ) :
                                (
                                    <div className='sm:px-5 grid grid-cols-1 sm:grid-cols-2 mt-20 sm:gap-20 md:mt-30 gap-100 md:gap-75'>
                                        {items?.map((item, i) =>
                                            <ModuleGraphItem
                                                key={i}
                                                {...item} />
                                        )}
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

ModuleGraph.propTypes = {
    backgroundColor: PropTypes.string,
    singleGraphEditorialVariant: PropTypes.bool,
    title: PropTypes.string,
    parent: PropTypes.string,
    itemsCollection: PropTypes.object
};

export default ModuleGraph;
